module.exports = __webpack_public_path__ + "media/images/riders/CARLOS_COLOMA_NICOLAS-0e4942a4b316a491eccb7964da63f977.png";